import React, { FC } from 'react';

import { Container } from '@lglp/components';
import {
  FooterCardType,
  IconCardsContainer,
  MultipleCardsContainer,
  SimpleCardContainer,
} from '@lglp/prismic-client';

import styles from './FooterCards.module.scss';
import { IconCardsContainerSlice } from './IconCardsContainer';
import { MultipleCardsContainerSlice } from './MultipleCardsContainer';
import { SimpleCardContainerSlice } from './SimpleCardContainer';

const FooterCardsPart: FC<FooterCardsPartProps> = ({ data, className }) => {
  const { type, ...rest } = data;
  return (
    <Container className={className}>
      {type === FooterCardType.MULTIPLE && (
        <MultipleCardsContainerSlice data={rest as MultipleCardsContainer} />
      )}
      {type === FooterCardType.SIMPLE && (
        <SimpleCardContainerSlice data={rest as SimpleCardContainer} />
      )}
      {type === FooterCardType.ICON && (
        <IconCardsContainerSlice data={rest as IconCardsContainer} />
      )}
    </Container>
  );
};

type FooterCardsPartProps = {
  data: MultipleCardsContainer | SimpleCardContainer | IconCardsContainer;
  className?: string;
};

export const FooterCards: FC<FooterCardsProps> = ({ cards, className }) => {
  const { left, right } = cards || {};
  return (
    <Container className={[styles.footerCardsContainer, className]}>
      {left && <FooterCardsPart className={styles.left} data={left} />}
      {right && <FooterCardsPart className={styles.right} data={right} />}
    </Container>
  );
};

type FooterCardsProps = {
  cards: Record<string, any>;
  className?: string;
};
